// extracted by mini-css-extract-plugin
export default {"container":"RegistrationPlan_container__Xym5b"};